<template>
  <div v-loading="filterLoading">
    <div style="margin-bottom: 20px;">
      <el-form>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              label="Számlatömb"
            >
              <el-select
                v-model="invoiceBook"
                value-key="id"
                style="width: 100%;"
                @change="fetchData"
                filterable
              >
                <el-option
                  v-for="s in invoiceBooks"
                  :key="s.id"
                  :label="s.name"
                  :value="s"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item
              label="Dátum"
            >
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                :clearable="true"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="dateRangeOptions"
                style="margin-right: 10px; width: 100%;"
                @change="fetchData"
              />
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item
              label="Számlasorszámtól"
            >
              <el-input
                type="number"
                size="medium"
                @change="fetchData"
                v-model="invoiceNumberFrom">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              label="Számlasorszámig"
            >
              <el-input
                type="number"
                @change="fetchData"
                size="medium"
                v-model="invoiceNumberTo">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <div class="" style="text-align: right; margin-top: 40px;">
              <el-button
                :loading="downloadLoading"
                icon="el-icon-download"
                @click="download"
              >
                XML Exportálás
              </el-button>
            </div>
          </el-col>

        </el-row>
      </el-form>

    </div>
    <el-table
      v-loading="loading"
      :data="invoices"
    >
      <el-table-column
        label="Számlasorszám"
        prop="invoice_number"
        width="130"
      >
        <template slot-scope="scope">
          {{ scope.row.invoice_number }}
        </template>
      </el-table-column>

      <el-table-column
        label="Számla típusa"
        prop="type"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type === 'CREATE' && !scope.row.is_advance" size="small"
                  type="success">Normál
          </el-tag>
          <el-tooltip
            v-if="scope.row.type === 'STORNO' && !scope.row.is_advance"
            effect="dark"
            :content="`Sztornózza a következőt: ${scope.row.cancelled_invoice_number}`"
            placement="right"
          >
            <el-tag v-if="scope.row.type === 'STORNO' && !scope.row.is_advance" size="small"
                    type="danger">Sztornó
            </el-tag>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.type === 'MODIFY' && !scope.row.is_advance"
            effect="dark"
            :content="`Módosítja a következőt: ${scope.row.modified_invoice_number}`"
            placement="right"
          >
            <el-tag v-if="scope.row.type === 'MODIFY' && !scope.row.is_advance" size="small"
                    type="warning">Módosító okirat
            </el-tag>
          </el-tooltip>
          <el-tag v-if="scope.row.is_advance" size="small" type="success">Előleg</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="Számla kelte"
        prop="issue_date"
      >
        <template slot-scope="scope">
          {{ scope.row.issue_date}}
        </template>
      </el-table-column>

      <el-table-column
        label="Tejlesítés dátuma"
        prop="delivery_date"
      >
        <template slot-scope="scope">
          {{ scope.row.delivery_date}}
        </template>
      </el-table-column>


      <el-table-column
        label="Vevő neve"
        prop="customer_name"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.customer_name}}
        </template>
      </el-table-column>


      <el-table-column
        label="Nettó összeg"
        prop="net_price"
        align="right"
      >
        <template slot-scope="scope">
          {{ scope.row.net_price | currency }}
        </template>
      </el-table-column>


      <el-table-column
        label="Bruttó összeg"
        prop="gross_price"
        align="right"
      >
        <template slot-scope="scope">
          {{ scope.row.gross_price | currency}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import moment from 'moment';
import { saveAs } from 'file-saver';

export default {
  data() {
    const start = moment()
      .startOf('year')
      .format('Y-MM-DD');
    const end = moment()
      .format('Y-MM-DD');
    return {
      loading: false,
      invoices: [],
      invoiceNumberFrom: '',
      invoiceNumberTo: '',
      filterLoading: false,
      downloadLoading: false,
      invoiceBook: null,
      dateRange: [start, end],
      dateRangeOptions: {
        firstDayOfWeek: 1,
        shortcuts: [{
          text: 'Aktuális hét',
          onClick(picker) {
            const start = moment()
              .weekday(1)
              .toDate();
            const end = moment()
              .weekday(7)
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző hét',
          onClick(picker) {
            const start = moment()
              .subtract({ weeks: 1 })
              .weekday(1)
              .toDate();
            const end = moment()
              .subtract({ weeks: 1 })
              .weekday(7)
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Aktuális hónap',
          onClick(picker) {
            const start = moment()
              .startOf('month')
              .toDate();
            const end = moment()
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző hónap',
          onClick(picker) {
            const start = moment()
              .subtract({ months: 1 })
              .startOf('month')
              .toDate();
            const end = moment()
              .subtract({ months: 1 })
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző 3 hónap',
          onClick(picker) {
            const start = moment()
              .subtract({ months: 3 })
              .startOf('month')
              .toDate();
            const end = moment()
              .subtract({ months: 1 })
              .endOf('month')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Aktuális év',
          onClick(picker) {
            const start = moment()
              .startOf('year')
              .toDate();
            const end = moment()
              .endOf('year')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Előző év',
          onClick(picker) {
            const start = moment()
              .subtract({ years: 1 })
              .startOf('year')
              .toDate();
            const end = moment()
              .subtract({ years: 1 })
              .endOf('year')
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'YTD',
          onClick(picker) {
            const start = moment()
              .startOf('year')
              .toDate();
            const end = moment()
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'MTD',
          onClick(picker) {
            const start = moment()
              .startOf('month')
              .toDate();
            const end = moment()
              .toDate();
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    };
  },

  computed: {
    invoiceBooks() {
      return this.$store.getters['invoiceBook/invoiceBooks'];
    },
  },

  methods: {
    async fetchData() {
      this.loading = true;
      let query = '?invoice_book_id=' + this.invoiceBook.id;

      if (this.dateRange) {
        query += '&from=' + this.dateRange[0] + '&to=' + this.dateRange[1];
      }

      if (this.invoiceNumberFrom) {
        query += '&invoice_number_from=' + this.invoiceNumberFrom;
      }

      if (this.invoiceNumberTo) {
        query += '&invoice_number_to=' + this.invoiceNumberTo;
      }

      this.invoices = await axios.get('api/reports/nav-audit' + query);
      this.loading = false;
    },

    async download() {
      this.downloadLoading = true;

      let data = {
        invoice_book_id: this.invoiceBook.id
      };

      if (this.dateRange) {
        data.from = this.dateRange[0];
        data.to = this.dateRange[1];
      }

      if (this.invoiceNumberFrom) {
        data.invoice_number_from = this.invoiceNumberFrom;
      }

      if (this.invoiceNumberTo) {
        data.invoice_number_to = this.invoiceNumberTo;
      }

      try {
        const excel = await axios({
          url: `api/reports/nav-audit/export`,
          method: 'POST',
          responseType: 'blob',
          data,
        });
        saveAs(excel, `NAV-audit.xml`);
      } catch (e) {
      }
      this.downloadLoading = false;
    },
  },

  async mounted() {
    this.filterLoading = true;
    if (!this.invoiceBooks || !this.invoiceBooks.length) {
      await this.$store.dispatch('invoiceBook/fetchAll', '');
    }
    this.filterLoading = false;

  },
};
</script>
